// extracted by mini-css-extract-plugin
export var actionText = "_kn-4";
export var container = "_kn-0";
export var leftSection = "_kn-1";
export var rightSection = "_kn-2";
export var settingsButton = "_kn-6";
export var settingsIcon = "_kn-7";
export var shortcut = "_kn-5";
export var shortcutGroup = "_kn-3";